import { useEffect } from 'react';
import { SITE_URL } from '../content/site';

/**
 * Sets the document title, meta description and canonical URL for a route.
 * index.html keeps site-wide defaults for crawlers that do not run scripts;
 * this hook updates those same elements, so the head never holds duplicates.
 */
export function usePageMeta(title: string, description: string, path: string): void {
  useEffect(() => {
    document.title = title;

    const setMeta = (selector: string, attr: string, value: string) => {
      const el = document.head.querySelector<HTMLElement>(selector);
      el?.setAttribute(attr, value);
    };

    const url = `${SITE_URL}${path}`;
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('link[rel="canonical"]', 'href', url);
  }, [title, description, path]);
}
